import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {
  Fab,
  Paper,
  Radio,
  Modal,
  FormLabel,
  TextField,
  RadioGroup,
  withStyles,
  Typography,
  FormControl,
  FormControlLabel,
} from '@material-ui/core'
import {
  Add as AddIcon,
} from '@material-ui/icons'
import { connect } from 'react-redux'

import { exportsCastingsCSV } from '../actions/export'
import { getCastings, createCasting } from '../actions/castings'
import { LIST_TYPE, ROUTES, USER_TYPE } from '../constant'
import Button from '../components/Button'
import Breadcrumb from '../components/Breadcrumbs'
import CastingAutomation from '../components/CastingAutomation'


const styles = theme => ({
  modalContainer: {
    top: '50%',
    left: '50%',
    padding: 30,
    width: '90%',
    height: '80vh',
    maxWidth: 500,
    maxHeight: 465,
    minHeight: 300,
    outline: 'none',
    overflowY: 'auto',
    position: 'absolute',
    backgroundColor: 'white',
    transform: 'translateX(-50%) translateY(-50%)',
  },
  fab: {
    position: 'fixed',
    right: theme.spacing(1),
    bottom: theme.spacing(1),
  },
  modalSubmit: {
    marginTop: 30,
  },
})


class ListCasting extends Component {
  /* LIFECYCLE */

  state = {
    type: '',
    name: '',
    email: '',
    brand: '',
    lastQuery: '',
    lastOptions: {},
    modalOpened: false,
  }


  /* METHODS */

  handleItemClick = (item) => {
    this.props.history.push(`${ROUTES.CASTINGS}/${item.objectID}`)
  }

  handleGetCastings = (query, options) => {
    const { list } = this.props

    this.props.getCastings(query, {
      sort: list.sort || '',
      ...options,
    })

    this.setState({
      lastQuery: query,
      lastOptions: options,
    })
  }

  handleSortChange = (sort) => {
    const { lastQuery, lastOptions } = this.state

    return this.handleGetCastings(lastQuery, {
      ...lastOptions,
      sort,
    })
  }

  handleChange = e => this.setState({ [e.target.name]: e.target.value })

  handleOpenModal = () => this.setState({ modalOpened: true })

  handleCloseModal = () => this.setState({
    type: '',
    name: '',
    email: '',
    modalOpened: false,
  })

  handleCreateCasting = () => {
    this.props.createCasting({
      type: this.state.type,
      name: this.state.name,
      brand: this.state.brand,
      email: this.state.email,
    })

    this.handleCloseModal()
  }


  /* RENDER */

  /**
   * @render
   * @returns {JSX}
   */
  render() {
    const {
      list,
      classes,
      isLoading,
    } = this.props
    const {
      type,
      name,
      email,
      brand,
      modalOpened,
    } = this.state
    const isSubmitable = name && email && type

    return (
      <div>
        <Breadcrumb
          data={[
            { label: 'Home', to: ROUTES.HOME },
            'Castings',
          ]}
        />

        <Fab
          color="primary"
          aria-label="add"
          component={Fab}
          className={classes.fab}
          onClick={this.handleOpenModal}
        >
          <AddIcon />
        </Fab>

        <CastingAutomation
          isLoading={isLoading}
          onClick={this.handleItemClick}
          request={this.handleGetCastings}
          onSortChange={this.handleSortChange}
          onExport={this.props.exportsCastingsCSV}
          {...list}
        />

        <Modal
          open={modalOpened}
          onClose={this.handleCloseModal}
        >
          <Paper className={classes.modalContainer}>
            <Typography variant="h4" color="primary">Create a new casting</Typography>
            <br />

            <form noValidate>
              <TextField
                required
                fullWidth
                name="name"
                label="Name"
                value={name}
                margin="normal"
                variant="outlined"
                onChange={this.handleChange}
              />
              <TextField
                required
                fullWidth
                name="brand"
                label="Brand"
                value={brand}
                margin="normal"
                variant="outlined"
                onChange={this.handleChange}
              />
              <TextField
                required
                fullWidth
                type="email"
                name="email"
                value={email}
                label="E-mail"
                margin="normal"
                variant="outlined"
                onChange={this.handleChange}
              />

              <FormControl component="fieldset" className="mt3">
                <FormLabel component="legend">Type</FormLabel>
                <RadioGroup
                  name="type"
                  value={type}
                  aria-label="type"
                  onChange={this.handleChange}
                >
                  <FormControlLabel
                    label="Model"
                    control={<Radio />}
                    value={USER_TYPE.MODEL}
                  />

                  <FormControlLabel
                    label="Photograph"
                    control={<Radio />}
                    value={USER_TYPE.PHOTOGRAPHER}
                  />
                </RadioGroup>
              </FormControl>

              <Button
                fullWidth
                color="primary"
                variant="contained"
                disabled={!isSubmitable}
                className={classes.modalSubmit}
                onClick={this.handleCreateCasting}
              >
                Submit
              </Button>
            </form>
          </Paper>
        </Modal>
      </div>
    )
  }
}


ListCasting.propTypes = {
  list: PropTypes.object,
  isConnected: PropTypes.bool,
  classes: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  history: PropTypes.object.isRequired,
  getCastings: PropTypes.func.isRequired,
  createCasting: PropTypes.func.isRequired,
  exportsCastingsCSV: PropTypes.func.isRequired,
}


const mapStateToProps = state => ({
  isLoading: state.app.isLoading,
  isConnected: state.user.isConnected,
  list: state.list.collection === LIST_TYPE.CASTING ? state.list : {
    page: 0,
    count: 0,
    sort: '',
    items: [],
    totalPages: 0,
  },
})


export default connect(mapStateToProps, {
  getCastings,
  createCasting,
  exportsCastingsCSV,
})(withStyles(styles)(ListCasting))
